import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { HintsByServiceCompanyAndType } from '../RequestsHints/components/HintsByServiceCompanyAndType/HintsByServiceCompanyAndType';
import {
  getHintsByRequestType,
  getHintsByServiceCompany,
} from './api/hintsQuery';

export const RequestHintsModal = ({ visible, houseId, typeId, onClose }) => {
  const [hintsByServiceCompany, setHintsByServiceCompany] = useState([]);
  const [hintsByRequestType, setHintsByRequestType] = useState([]);

  useEffect(() => {
    if (!visible) return;

    let isCancelled = false;

    const loadHints = async () => {
      const [serviceCompanyHints, requestTypeHints] = await Promise.all([
        houseId ? getHintsByServiceCompany({ houseId }) : [],
        houseId || typeId ? getHintsByRequestType({ houseId, typeId }) : [],
      ]);

      if (!isCancelled) {
        setHintsByServiceCompany(serviceCompanyHints || []);
        setHintsByRequestType(requestTypeHints || []);
      }
    };

    loadHints();

    return () => {
      isCancelled = true;
    };
  }, [visible, houseId, typeId]);

  return (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      width={500}
      bodyStyle={{ padding: 0 }}
      onCancel={onClose}
      destroyOnClose
    >
      <HintsByServiceCompanyAndType
        hintsByServiceCompany={hintsByServiceCompany}
        hintsByRequestType={hintsByRequestType}
        setVisible={onClose}
      />
    </Modal>
  );
};
